import { useChartTooltipOptions } from '../hooks';
import { ChartECOption } from '../types';
import { GetChartGridOptionArgs, getChartGridOption } from './getChartGridOption';
import { GetChartSeriesOptionArgs, getChartSeriesOption } from './getChartSeriesOption';
import { GetChartXAxisOptionArgs, getChartXAxisOption } from './getChartXAxisOption';
import { GetChartYAxisOptionArgs, getChartYAxisOption } from './getChartYAxisOption';

interface GetChartOptionsArgs {
  seriesArgs: GetChartSeriesOptionArgs;
  xAxisArgs: GetChartXAxisOptionArgs;
  yAxisArgs: GetChartYAxisOptionArgs;
  gridArgs: GetChartGridOptionArgs;
}

export function getChartOptions({ seriesArgs, xAxisArgs, yAxisArgs, gridArgs }: GetChartOptionsArgs): ChartECOption {
  const tooltip = useChartTooltipOptions();
  const grid = getChartGridOption(gridArgs);

  const series = getChartSeriesOption(seriesArgs);
  const xAxis = getChartXAxisOption(xAxisArgs);
  const yAxis = getChartYAxisOption(yAxisArgs);

  return { grid, tooltip, xAxis, yAxis, series };
}
